// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresSeasonUpdateBody = {
  poolId: string;
  squaresSeasonId: string;
  maxPerMember?: number | null;
  autoLock?: boolean;
  showNumbers?: boolean;
  carrySquares?: boolean;
  redrawNumbers?: boolean;
  autoPublish?: boolean;
  size?: number;
  axes?: {
    kind: "teamNames" | "winnerLoser" | "homeAway" | "teamOpponent" | "custom";
    topLabel?: string | null;
    sideLabel?: string | null;
    teamId?: string | null;
  };
  checkpoints?: string[];
};

export type typeSquaresSeasonUpdateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    season: {
      squaresSeasonId: string;
      seasonNumber: number;
      gridType: "classic" | "shared";
      leagueKey: string;
      gameRule: {
        presetKey:
          | "oneGame"
          | "allGames"
          | "tnf"
          | "snf"
          | "mnf"
          | "thanksgiving"
          | "christmas"
          | "playoffs"
          | "conference"
          | "team"
          | "bowls"
          | "cfp"
          | "ncaaTournament"
          | "conferenceTournaments"
          | "openingDay"
          | "worldSeries"
          | "matchdayRange"
          | "customDates";
        seasonYear?: number | null;
        eventId?: string | null;
        teamId?: string | null;
        conferenceKey?: string | null;
        customDates?: {
          mode: "range" | "dates";
          fromDay?: string;
          toDay?: string;
          days?: string[];
        } | null;
        excludedEventIds: string[];
      };
      gamesLabel: string;
      gamesWindowLabel?: string | null;
      gameCount: number;
      axes: {
        kind:
          "teamNames" | "winnerLoser" | "homeAway" | "teamOpponent" | "custom";
        topLabel?: string | null;
        sideLabel?: string | null;
        teamId?: string | null;
      };
      checkpoints: {
        checkpointKey:
          | "q1"
          | "half"
          | "q3"
          | "p1"
          | "p2"
          | "after3"
          | "after5"
          | "after7"
          | "final";
        label: string;
      }[];
      gridSettings: {
        size: number;
        maxPerMember?: number | null;
        autoLock: boolean;
        showNumbers: boolean;
      };
      newGrid: {
        carrySquares: boolean;
        redrawNumbers: boolean;
        autoPublish: boolean;
      };
      isFrozen: boolean;
      frozenFields: string[];
      canStartNewSeason: boolean;
    };
  };
};

export type typeSquaresSeasonUpdateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSeasonUpdateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSeasonUpdateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresSeasonUpdateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    squaresSeasonId: { type: "string", maxLength: 3000, minLength: 1 },
    maxPerMember: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    autoLock: { type: "boolean" },
    showNumbers: { type: "boolean" },
    carrySquares: { type: "boolean" },
    redrawNumbers: { type: "boolean" },
    autoPublish: { type: "boolean" },
    size: { type: "integer" },
    axes: {
      type: "object",
      properties: {
        kind: {
          type: "string",
          enum: [
            "teamNames",
            "winnerLoser",
            "homeAway",
            "teamOpponent",
            "custom",
          ],
        },
        topLabel: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
        sideLabel: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
        teamId: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
      },
      required: ["kind"],
    },
    checkpoints: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["poolId", "squaresSeasonId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresSeasonUpdate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresSeasonUpdateBody);
  }

  return async function postSquaresSeasonUpdate(
    payload: typeSquaresSeasonUpdateBody,
  ): Promise<
    typeSquaresSeasonUpdateOutput200 | typeSquaresSeasonUpdateOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresSeasonUpdate" failed before calling the network. #f397ec90f460`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#f397ec90f460" },
        },
        data: null,
      } as typeSquaresSeasonUpdateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/season-update`,
      httpMethod: "POST",
      options,
    })) as typeSquaresSeasonUpdateOutput200 | typeSquaresSeasonUpdateOutput400;
  };
}
